import { useState } from 'react';
import { resetPasswordRequest } from '@services/auth/authApi';

// Handles reset-password token submission and UI state.
function useResetPassword() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  async function resetPassword(token, newPassword) {
    // Clear previous result state before attempting a new reset.
    setError('');
    setSuccess('');
    setIsSubmitting(true);
    try {
      const response = await resetPasswordRequest({ token, newPassword });
      setSuccess(response?.message || 'Contrasena actualizada correctamente.');
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return { resetPassword, isSubmitting, error, success };
}

export default useResetPassword;
